module.exports = __webpack_public_path__ + "img/service-about-2.71f0f29e.jpg";